import { useEffect } from "react";
import { useForm, SubmitHandler } from 'react-hook-form';
// Redux Info
import { useAppSelector, useAppDispatch  } from '../redux/hooks';
import {selectApi } from '../redux/reducers/MainReducer';
import {setUpFailedCreateNewBudget2sqlHelperTableModal,
        createNewBudget2sqlHelperTableAsync,
        setUpCreateNewBudget2sqlHelperTableAdded,
        selectCreateNewBudget2sqlHelperTableAdded,
        selectCreateNewBudget2sqlHelperTableModal,
        budgetHelperTableAsync} from '../redux/reducers/Budget2SqlReducer';
import { InfoModal } from "./shared/InfoModal";

interface IFormInput {
    name: string;
    inputTableName: string;
}

interface IBudgetCreateHelperProps {
    productId: string
}

const BudgetCreateHelperTable = (props:IBudgetCreateHelperProps) => {
    const {  register,
        handleSubmit} = useForm<IFormInput>({ 
        mode: "onChange"
    });
    
    // Redux Selector
    const api = useAppSelector(selectApi);
    const modalState = useAppSelector(selectCreateNewBudget2sqlHelperTableModal);
    const isHelperTableAdded= useAppSelector(selectCreateNewBudget2sqlHelperTableAdded);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if(isHelperTableAdded){
            const id = props.productId
            dispatch(budgetHelperTableAsync({api, id}))
        } 
    }, [isHelperTableAdded]);

    const onSubmit: SubmitHandler<IFormInput> = (data:any) => {
        const helperTableName = data.name
        const inputTableName = data.inputTableName
        const productId = props.productId
        dispatch(createNewBudget2sqlHelperTableAsync({api, helperTableName, inputTableName, productId}))
    };
    return (
        <div>
            <InfoModal
                header={modalState.header}
                message={modalState.message}
                open={modalState.open}
                success={modalState.success}
                onOK={() => {
                    dispatch(setUpFailedCreateNewBudget2sqlHelperTableModal())
                }}
            />
            <button 
                hidden = {!isHelperTableAdded}
                className ="btn btn-sm btn-primary"
                onClick = {()=> dispatch(setUpCreateNewBudget2sqlHelperTableAdded(false))}>Add New Helper</button>
            <form onSubmit={handleSubmit(onSubmit)}> 
                <br />
                <div className="row">
                    <div className="form-group col-6">
                        <input type="text"
                            className="form-control" 
                            id="name" 
                            hidden={isHelperTableAdded}
                            placeholder="Enter the Helper name"
                            {...register("name", { required: true})} 
                        />
                    </div>
                    <div className="form-group col-6">
                        <input type="text"
                            className="form-control" 
                            id="inputTableName" 
                            hidden={isHelperTableAdded}
                            placeholder="Enter the Sql Table Name"
                            {...register("inputTableName", { required: true})} 
                        />
                    </div>
                    <div className="form-group col-2 mr-1">
                        <button 
                            type="submit" 
                            hidden={isHelperTableAdded}
                            className="btn btn-md btn-primary text-uppercase"
                        >Add</button>
                    </div>
                    <div className="form-group col-2">
                        <button 
                            className="btn btn-secondary btn-md text-uppercase"
                            hidden={isHelperTableAdded}
                            onClick={()=>dispatch(setUpCreateNewBudget2sqlHelperTableAdded(true))} 
                        >Cancel</button>
                    </div>
                </div> 
            </form>
        </div>
    )
}

export default BudgetCreateHelperTable;